import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import PublicTicketTypeDropDown from "./PublicTicketTypeDropDown";
import logo from "../../assets/images/logo/logo_1.svg";

function PublicSupportTicket() {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trackingNo, setTrackingNo] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    const data = {
      FullName: event.target.fullName.value.trim(),
      ContactNo: event.target.contactNo.value.trim(),
      Subject: event.target.subject.value.trim(),
      Description: event.target.description.value.trim(),
      TicketType: event.target.type.value,
      TicketSource: "Website",
      FileAttached: "",
    };

    axios({
      method: "post",
      url: config.base_url + "Support/AddPublicSupportTicket",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setTrackingNo(response.data.TrackingNo || response.data.TicketID || "");
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          form.reset();
          setValidated(false);
        } else {
          toast.error(response.data.status_message || "Could not submit ticket.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="content-center">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center mb-4">
                <img src={logo} alt="School" style={{ maxHeight: 72 }} />
                <h2 className="mt-3 mb-1">Support request</h2>
                <p className="text-muted small">
                  Submit a ticket without signing in. Our team will contact you on the number provided.
                </p>
              </div>
              <div className="card">
                <div className="card-body p-md-4">
                  {trackingNo ? (
                    <p className="alert alert-success small">
                      Reference: <strong>{trackingNo}</strong>
                    </p>
                  ) : null}
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="row gy-3">
                      <div className="col-md-6">
                        <label className="form-label">Full name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="fullName"
                          required
                          maxLength={200}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Contact number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactNo"
                          required
                          maxLength={50}
                          placeholder="e.g. 923001234567"
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="form-label">Subject</label>
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          required
                          maxLength={200}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="form-label">Department</label>
                        <select className="form-select" name="type" required>
                          <option value="">Select department</option>
                          <PublicTicketTypeDropDown />
                        </select>
                      </div>
                      <div className="col-md-12">
                        <label className="form-label">Message</label>
                        <textarea
                          className="form-control"
                          name="description"
                          rows="6"
                          required
                        />
                      </div>
                      <div className="col-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <Link to="/login">Staff / student sign in</Link>
                        <button
                          type="submit"
                          className="button button-primary"
                          disabled={loading}
                        >
                          {loading ? "Submitting…" : "Submit ticket"}
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PublicSupportTicket;
